import get from 'lodash/get';
import { eventBus, EVENTS } from "../event-bus/EventBus";

const MixinHelper = {
    methods: {
        filterParams(query) {
            let queryFilter = {};
            Object.keys(query).forEach(key => {
                if (query[key] !== null && query[key] !== undefined && query[key] !== 0) {
                    queryFilter[key] = query[key];
                }
            });
            return queryFilter;
        },
        getProp: get,
        buildDataCreateOrder(formData) {
            const seat_ids = formData.seats.map(s => s.id);
            const schedule_id = formData.schedule_id;
            const ticket_quantity = seat_ids.length;
            const pick_up_locations = formData.places.pickupLocations.map(pickup => {
                if (pickup.hasOwnProperty('people_quantity')) {
                    return pickup;
                }
                return {...pickup, people_quantity: seat_ids.length}
            });
            const get_off_locations = formData.places.getOffLocations.map(getOff => getOff.address || '');
            const phone_number = formData.customer.phone_number;
            const customer_name = formData.customer.name;
            const note = formData.customer.note;
            let data = {};
            data = {
                ...data,
                schedule_id,
                ...formData.query_params,
                seat_ids,
                ticket_quantity,
                pick_up_locations,
                get_off_locations,
                phone_number,
                customer_name,
                note
            };

            return data;
        },
        isPeopleQuantityPickupEqualsSeatQuantity(form) {
            const people_quantity_total = form.places.pickupLocations.map(pickup => pickup.people_quantity).reduce((a, b) => Number(a) + Number(b), 0);
            const seat_total = form.seats.length;
            return people_quantity_total === seat_total;
        },
        storeData(name, data) {
            localStorage.setItem(name, JSON.stringify(data));
        },
        retrieveData(name) {
            let data = JSON.parse(localStorage.getItem(name));
            const now = (new Date()).valueOf();
            if (data && data.hasOwnProperty('expire')) {
                if (data.expire < now) {
                    localStorage.removeItem(name);
                    data = null;
                }
            }
            return data;
        },
        removeDatas(names) {
            const self = this;
            names.forEach(function (name) {
                self.removeData(name);
            })
        },
        removeData(name) {
            localStorage.removeItem(name);
        },
        addItemLocation(location = 'pickup') {
            if (location === 'pickup') {
                eventBus.$emit(EVENTS.add_pickup_location);
            } else if (location === 'getOff') {
                eventBus.$emit(EVENTS.add_getOff_location);
            }
        },
        removeItemLocation(location = 'pickup', item) {
            if (location === 'pickup') {
                eventBus.$emit(EVENTS.remove_pickup_location, item);
            } else if (location === 'getOff') {
                eventBus.$emit(EVENTS.remove_getOff_location, item);
            }
        }
    }
};

export default MixinHelper;
